import Vue from 'vue'
import { getField, updateField } from 'vuex-map-fields'

const formTemplate = {
  status: 'pending',
  type: '',
  customer_id: '',
  customer_name: '',
  customer_email: '',
  customer_phone: '',
  customer_country: '',
  customer_company: '',
  save_details: true,
  origins: [],
  destinations: [],
  date: null,
  time: null,
  confirmed: false,
  metadata: {}
}

const addressTemplate = {
  contact_name: '',
  contact_email: '',
  contact_phone: '',
  formatted_address: '',
  address_1: '',
  address_2: '',
  city: '',
  zip: '',
  country: '',
  latitude: null,
  longitude: null,
  notes: '',
  products: [],
  addons: []
}

export default {
  namespaced: true,

  state: {
    addressTemplate,
    options: {},
    form: JSON.parse(JSON.stringify(formTemplate))
  },

  getters: {
    getField,

    steps (state, getters) {
      let array = []

      array.push({ 
        icon: 'details',
        name: 'Details',
        route: 'BookDetails',
        title: 'Enter Your Details'
      })

      if (state.options.type === 'pickup' || state.options.type === 'transport') {
        array.push({ 
          icon: 'map-marker-alt',
          name: 'Pickup',
          route: 'BookOrigin',
          title: 'Enter Pickup Address'
        })
      }

      if (state.options.type !== 'pickup') {
        array.push({ 
          icon: 'location',
          name: 'Delivery',
          route: 'BookDestination',
          title: 'Enter Delivery Address'
        })
      }

      if (state.options.date_requirement === 'required' || state.options.date_requirement === 'optional') {
        array.push({ 
          icon: 'calendar-day',
          name: 'Date',
          route: 'BookDate',
          title: 'Choose Pickup Date'
        })
      }

      if (state.options.time_requirement === 'required' || state.options.time_requirement === 'optional') {
        array.push({ 
          icon: 'clock',
          name: 'Time',
          route: 'BookTime',
          title: 'Choose Ready Time'
        })
      }

      array.push({ 
        icon: 'check-circle',
        name: 'Confirm',
        route: 'BookConfirm',
        title: 'Confirm Your Booking'
      })

      return array
    },
    
    currentStep (state, getters, rootState) {
      return getters.steps.find(step => step.route === rootState.route.name)
    },

    currentIndex (state, getters) {
      if (getters.currentStep) {
        return getters.steps.findIndex(step => step.route === getters.currentStep.route)
      } else {
        return null
      }
    },

    addressTotals (state) {
      const origins = []
      const destinations = []
      
      state.form.origins.forEach((origin) => {
        let object = {
          products: 0,
          addons: 0,
          total: 0
        }

        if (origin.products) {
          origin.products.forEach((product) => {
            object.products += product.quantity
            object.total += product.price * product.quantity
          })
        }

        if (origin.addons) {
          object.addons = origin.addons.length
        }

        origins.push(object)
      })

      state.form.destinations.forEach((destination) => {
        let object = {
          products: 0,
          addons: 0,
          total: 0
        }

        if (destination.products) {
          destination.products.forEach((product) => {
            object.products += product.quantity
            object.total += product.price * product.quantity
          })
        }

        if (destination.addons) {
          object.addons = destination.addons.length
        }

        destinations.push(object)
      })

      return {
        origins,
        destinations
      }
    },
  },

  mutations: {
    updateField,

    addAddress (state, { type, id, address }) {
      state.form[type].push({ id, ...address })
    },

    removeAddress (state, { type, index }) {
      Vue.delete(state.form[type], index)
    },

    updateAddress (state, { type, index, address }) {
      Vue.set(state.form[type], index, address)
    },

    updateOptions (state, options) {
      state.options = options
    },

    resetForm (state) {
      state.form = JSON.parse(JSON.stringify(formTemplate))
      window.localStorage.removeItem(`bookingFormAutosave`)
    },

    loadTestData (state) {
      state.form = {
        status: 'pending',
        type: 'transport',
        customer_id: '',
        customer_name: '',
        customer_email: '',
        customer_phone: '',
        customer_country: '',
        customer_company: '',
        save_details: true,
        origins: [
          {
            address_1:'110 Campground Rd, Rondebosch',
            address_2:'',
            city:'Cape Town',
            contact_email:'',
            contact_name:'Andrew',
            contact_phone:'0839423067',
            country:'ZA',
            formatted_address:'110 Campground Rd, Rondebosch, Cape Town, 7700, South Africa',
            id:1605252513224,
            latitude:-33.967574,
            longitude:18.474348,
            name:'Fleetbeacon (Pty) Ltd.',
            notes:'Hoot when outside',
            zip:'7700'
          }
        ],
        destinations: [
          {
            address_1:'66 Keerom St, Cape Town City Centre',
            address_2:'',
            city:'Cape Town',
            contact_email:'',
            contact_name:'Stefan Grobler',
            contact_phone:'',
            country:'ZA',
            formatted_address:'66 Keerom St, Cape Town City Centre, Cape Town, 8000, South Africa',
            id:1605252599140,
            latitude:-33.92609,
            longitude:18.41593,
            name:'Community Couriers',
            notes:'',
            zip:'8000',
            reference: 'INV1001'
          },
          {
            address_1:'77 Main Rd, Plumstead',
            address_2:'',
            city:'Cape Town',
            contact_email:'megg@fablebaby.co',
            contact_name:'Megg',
            contact_phone:'',
            country:'ZA',
            formatted_address:'77 Main Rd, Plumstead, Cape Town, 7801, South Africa',
            id:1605252644400,
            latitude:-34.0175544,
            longitude:18.4683042,
            name:'Fable Baby Co.',
            notes:'Bell broken',
            zip:'7801'
          }
        ],
        date: new Date(),
        time: null,
        confirmed: false,
        metadata: {}
      }
    },

    migrate (state) {
      // Migrate to add products and addons to schema
      state.form.origins.forEach(origin => {
        if (!origin.products) { origin.products = [] }
        if (!origin.addons) { origin.addons = [] }
      })
      
      state.form.destinations.forEach(destination => {
        if (!destination.products) { destination.products = [] }
        if (!destination.addons) { destination.addons = [] }
      })
    }
  },

  actions: {
    
  }
}
